import useDebounce from "./useDebounce";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { soegAdresser, vejnavneFraFund } from "../api/adressevaelger";

// type
type VejnavnResponse = {
  id: string;
  tekst: string;
  vejnavn: {
    navn: string;
  };
};

export default function useVejnavnAutoComplete() {
  // state
  const [inputValue, setQuery] = useState("");
  const debouncedInputValue = useDebounce(inputValue, 250);

  const { data, isPending } = useQuery({
    queryKey: ["vejnavne", debouncedInputValue],
    queryFn: async (): Promise<VejnavnResponse[]> =>
      vejnavneFraFund(await soegAdresser(debouncedInputValue, 50))
        .slice(0, 10)
        .map((navn, index) => ({
          id: String(index),
          tekst: navn,
          vejnavn: { navn },
        })),
    staleTime: Infinity,
  });

  return { data, isPending, debouncedInputValue, setQuery };
}
